import { ref, onMounted, onUnmounted } from "vue";

export function useConsentStatus() {
  const hasConsent = ref(!!localStorage.getItem("surveyConsent"));
  const testMode = ref(!!window.__SURVEY_TEST_MODE__);
  const isFormDisabled = ref(!hasConsent.value && !testMode.value);

  const checkConsent = () => {
    hasConsent.value = !!localStorage.getItem("surveyConsent");
    isFormDisabled.value = !hasConsent.value && !testMode.value;
  };

  onMounted(() => {
    window.addEventListener("storage", checkConsent);
    const interval = setInterval(checkConsent, 1000);
    onUnmounted(() => {
      window.removeEventListener("storage", checkConsent);
      clearInterval(interval);
    });
  });

  return { hasConsent, testMode, isFormDisabled };
}
